import React, { useState, useEffect } from 'react';
import UploadService from 'services/FileUploadService';
import { InputFieldUpload } from '../FormFields';
import LinearProgress from '@mui/material/LinearProgress';
import { Box, Typography, Button, ListItem, Grid } from '@mui/material';
import { withStyles } from '@mui/styles';
import { useSelector } from 'react-redux';

// import {
//   useFormikContext,
//   Formik,
//   Form,
//   Field,
//   ErrorMessage,
//   useField,
// } from 'formik';
// import { unstable_useControlled } from '@mui/utils';

//https://codesandbox.io/s/github/bezkoder/react-hooks-file-upload?file=/src/components/FileUpload.js
// https://codesandbox.io/s/github/bezkoder/material-ui-file-upload
//https://www.bezkoder.com/material-ui-file-upload/   <--- class component
//https://www.bezkoder.com/react-hooks-file-upload/   <--- function component

const BorderLinearProgress = withStyles((theme) => ({
  root: {
    height: 15,
    borderRadius: 5,
  },
  colorPrimary: {
    backgroundColor: '#EEEEEE',
  },
  bar: {
    borderRadius: 5,
    backgroundColor: '#1a90ff',
  },
}))(LinearProgress);

const UploadFiles002 = (props) => {
  const {
    // formField: { file1Name },
    // touched,
    // errors,
    // msg1,
    // uFile,
    // formikName,
    // formikValue,
    // formikTouch,
    // fileName,
    // selectedFiles,
    // setSelectedFiles,
    // currentFile,
    // setCurrentFile,
    // progress,
    // setProgress,
  } = props;

  const [selectedFiles, setSelectedFiles] = useState(undefined);
  const [currentFile, setCurrentFile] = useState(undefined);
  const [progress, setProgress] = useState(0);
  const [message, setMessage] = useState('');
  const [fileInfos, setFileInfos] = useState([]);
  // const formikProps = useFormikContext();
  //   const { file1Name } = formikProps;
  const [isError, setIsError] = useState(false);
  const [colorFile1Name, setColorFile1Name] = useState('primary');
  const { user: currentUser } = useSelector((state) => state.auth);

  // formikProps.setFieldValue('file1Name', []);
  // formikProps.setFieldValue('file1Name', formikProps.values.file1Name);
  // console.log(props.errors);

  //ทำงานใน PersonalForm
  // useEffect(() => {
  //   UploadService.getFiles().then((response) => {
  //     setFileInfos(response.data);
  //   });
  //   console.log('-----FileUpload--useEffect---->', selectedFiles);
  //   console.log('-----FileUpload--useEffect---->', formikName);
  //   // console.log('-----useEffect---->', selectedFiles);
  // }, []);

  // useEffect(() => {
  //   // console.log('-----errors---->', formikProps.values.file1Name[0]?.name);
  //   console.log('-----errors1---->', formikProps.touched.file1Name);
  //   console.log('-----errors2---->', formikProps.values.file1Name);
  // }, errors);

  // console.log('-----errors---->', formikProps.values.file1Name[0]?.name);
  // console.log('-----errors1---->', formikProps.touched.file1Name);
  // console.log('-----errors3---->', formikProps.values.file1Name);

  // console.log('-----errors3---if1--->', formikProps.values.file1Name);
  // setErrorFile1Name('primary');

  // console.log('-----errors3----else1--->', formikProps.touched.file1Name);
  // console.log('-----errors3----else2--->', formikProps.values.file1Name);

  // useEffect(() => {
  //   console.log('1111----' + formikProps.values.file1Name.length);
  //   // console.log('2222----' + formikProps.values['file1Name']);
  //   if (formikProps.values.file1Name.length > 0) {
  //   } else {
  //     if (formikProps.touched.file1Name) {
  //       if (formikProps.values.file1Name.length == 0) {
  //         setColorFile1Name('error');
  //       }
  //     }
  //   }
  // }, [formikProps.touched['file1Name']]);

  // useEffect(() => {
  //   console.log('3333----' + formikProps.touched['file1Name']);
  //   console.log('4444----' + formikProps.values['file1Name'].length);
  // }, []);

  const selectFile = async (event) => {
    // setSelectedFiles(event.target.files);
    //https://stackoverflow.com/questions/56149756/reactjs-how-to-handle-image-file-upload-with-formik

    // console.log('---selectFile----' + `${formikName}`);
    // console.log('---selectFile----' + `${msg1}`);
    console.log('---selectFile----' + JSON.stringify(event.target.name));

    const files = event.target.files;
    setSelectedFiles(files);
    setColorFile1Name('primary');
    let myFiles = Array.from(files);
    // formikProps.setFieldValue('file1Name', myFiles);
    // formikProps.setFieldValue(formikName, myFiles);

    const result = await resolveAfter2Seconds();
    // console.log(result);
    // console.log(files[1]);
    upload(files[0]);
  };

  function resolveAfter2Seconds() {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve('resolved1');
        // upload();
      }, 1500);
    });
  }

  const upload = (files) => {
    // let currentFile = selectedFiles[0];
    let currentFile = files;

    console.log('upload----' + files);
    // console.log('files----' + JSON.stringify(files));
    // if (!files) {
    //   // console.log('---files === undefined---');
    //   formikProps.setFieldValue(formikName, ''); //clear for formik validate
    //   console.log('---formikProps---' + formikProps.values[formikName]);
    // }

    setProgress(0);
    setCurrentFile(currentFile);

    // cotnst fileObj = { a: currentFile, b: currenUser };
    // const formData = new FormData();
    // formData.append('File', currentFile);
    // currentFile.name;

    UploadService.upload(
      currentFile,
      currentUser.username,
      'file2Name',
      (event) => {
        setProgress(Math.round((100 * event.loaded) / event.total));
      }
    )
      .then((response) => {
        setMessage(response.data.message);
        setIsError(false);
        return UploadService.getFiles();
      })
      .then((files) => {
        setFileInfos(files.data);
        console.log('---UploadService.upload---fileInfos---' + fileInfos);
      })
      .catch(() => {
        setProgress(0);
        setMessage('Could not upload the file!');
        setCurrentFile(undefined);
        setIsError(true);
      });

    setSelectedFiles(undefined);
  };

  const check1 = () => {
    return 'primary';
  };

  const validateFile1Name = (value) => {
    let error;
    console.log('-----validateFile1Name----', error);
    // if (value === 'admin') {
    //   error = 'Nice try!';
    // }
    return error;
  };

  const ShowFileName = () => {
    let test;
    test =
      selectedFiles && selectedFiles.length > 0 ? selectedFiles[0].name : null;
    // test =
    //   formikProps.values[formikName] &&
    //   formikProps.values[formikName].length > 0
    //     ? formikProps.values[formikName][0].name
    //     : null;
    // console.log('---ShowFileName--->', test);
    // return <div>{test}</div>;
    return <div className="file-name">{test}</div>;
  };

  const divErrorStyle1 = {
    color: '#D32F2F',
    fontSize: '14px',
  };

  return (
    <div className="mg20">
      {currentFile ? (
        <Box
          // key={formikName}
          className="mb25"
          display="flex"
          alignItems="center"
        >
          <Box width="100%" mr={1}>
            <BorderLinearProgress
              // name={formikName}
              // key={formikName}
              variant="determinate"
              value={progress}
            />
          </Box>
          <Box minWidth={35}>
            <Typography
              variant="body2"
              color="textSecondary"
              // key={formikName}
            >{`${progress}%`}</Typography>
          </Box>
        </Box>
      ) : (
        <Typography variant="caption" component="div" color="#1e88e5">
          {/* {msg1} -- */}
          {/* {JSON.stringify(uFile)} */}
        </Typography>
      )}
      <Box sx={{ flexGrow: 1 }}>
        <Grid container spacing={2} justifyContent="flex-start">
          <Grid item xs={6}>
            <label htmlFor="file2Name">
              <input
                id="file2Name"
                accept="image/*"
                name="file2Name"
                // name={file1Name.name}
                // key={formikName}
                style={{ display: 'none' }}
                type="file"
                onChange={selectFile}
                validate={validateFile1Name}
              />
              {/* ปุ่ม choose file */}
              <Button
                className="file2Name"
                color={colorFile1Name}
                variant="outlined"
                component="span"
                // name={formikName}
                // key={formikName}
              >
                Choose Files
              </Button>
            </label>
          </Grid>
          <Grid item xs={6}>
            {/* ชื่อไฟล์ */}
            <ShowFileName />
            {/* yup validate */}
            {/* {formikName} <br></br> */}
            {/* {file1Name.name} <br></br> */}
            {/* {`${formikName}`} */}
            <div style={divErrorStyle1}>
              {/* <ErrorMessage name="file1Name" component="div" /> */}
            </div>
            {/* error from API */}
            <Typography
              variant="subtitle2"
              className={`upload-message ${isError ? 'error' : ''}`}
            >
              {message}
            </Typography>
          </Grid>
          {/* ปิดปุ่ม upload */}
          {/* <Grid item xs={6}>
            <Button
              className="btn-upload"
              color="primary"
              variant="contained"
              component="span"
              disabled={!selectedFiles}
              onClick={upload}
            >
              Upload
            </Button>
          </Grid> */}
          <Grid item xs={6}></Grid>
        </Grid>
      </Box>
      {/* <label className="btn btn-default">
        <input
          type="file"
          onChange={selectFile}
          //   name={formikProps.values.file1Name.name}
          name={file1Name.name}
        />
        <ErrorMessage name={file1Name.name} component="div" />
        {/* <InputFieldUpload
          name={file1Name.name}
          label={file1Name.label}
          onChange={selectFile}
          // validate={validateUsername}
          // fullWidth
        /> * /}
      </label> */}

      {/* แบบนี้ก็ใช้ได้ */}
      {/* {formikProps.errors.file1Name && formikProps.touched.file1Name && (
        <div>{formikProps.errors.file1Name}</div>
      )} */}

      {/* {errors.file1Name && <div>{errors.file1Name}</div>} */}
      {/* <div className="file-name">
        {selectedFiles && selectedFiles.length > 0
          ? selectedFiles[0].name
          : null}
      </div> */}
      {/* <div className="file-name">
        {formikProps.values.file1Name && formikProps.values.file1Name.length > 0
          ? formikProps.values.file1Name[0].name
          : null}
      </div> */}
      {/* <div className="file-name">
        {selectedFiles && selectedFiles.length > 0
          ? formikProps.values.file1Name[0].name
          : formikProps.values.file1Name &&
            formikProps.values.file1Name.length > 0
          ? formikProps.values.file1Name[0].name
          : null}
      </div> */}

      {/* <Typography variant="h6" className="list-header">
        List of Files
      </Typography>
      <ul className="list-group">
        {fileInfos &&
          fileInfos.map((file, index) => (
            <ListItem divider key={index}>
              <a href={file.url}>{file.name}</a>
            </ListItem>
          ))}
      </ul> */}
    </div>
  );
};

export default UploadFiles002;
